/**
 * Rounds half away from zero at `places`. The magnitude is nudged up a few units of float precision
 * first: binary noise (2.135 × 100 = 213.49999999999997) would otherwise round a half down.
 * Arithmetic only, as the pricing engine rounds thousands of times per keystroke.
 */
export function roundHalfAwayFromZero(value: number, places: number): number {
  if (!Number.isFinite(value)) return value;
  const factor = 10 ** Math.max(0, Math.trunc(places));
  const scaled = Math.abs(value) * factor * (1 + 4 * Number.EPSILON);
  return (Math.sign(value) * Math.round(scaled)) / factor;
}
